<template>
    <v-container fluid>
        <v-row no-gutters class="d-block">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field
                                    :value="importacionMaestro.numero"
                                    label="Número de Importación"
                                    readonly
                                    prepend-icon="pin"
                                />

                                <v-text-field
                                    :value="importacionMaestro.unidad_operativa"
                                    label="Unidad Operativa"
                                    readonly
                                    prepend-icon="business"
                                />

                                <v-text-field
                                    :value="importacionMaestro.archivo_nombre"
                                    label="Archivo"
                                    readonly
                                    prepend-icon="attach_file"
                                />

                                <v-text-field
                                    :value="rangoRegistros"
                                    label="Números de registro de esta importación"
                                    readonly
                                    prepend-icon="confirmation_number"
                                    :hint="rangoConsecutivo ? '' : 'Los números no son consecutivos: hay saltos dentro del rango.'"
                                    persistent-hint
                                />
                            </v-col>

                            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field
                                    :value="importacionMaestro.nombres_apellidos"
                                    label="Importada por"
                                    readonly
                                    prepend-icon="person"
                                />

                                <v-text-field
                                    :value="importacionMaestro.fecha_crea | fechaESPHora"
                                    label="Fecha de Importación"
                                    readonly
                                    prepend-icon="today"
                                />

                                <v-text-field
                                    :value="importacionMaestro.fecha_actualiza | fechaESPHora"
                                    label="Fecha de Procesamiento"
                                    readonly
                                    prepend-icon="today"
                                />
                            </v-col>
                        </v-row>

                        <v-expansion-panels accordion v-model="panel" multiple>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-toolbar-title>Datos de la Importación</v-toolbar-title>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>

                                        <v-col cols="6" sm="6" md="6" lg="6" xl="6">

                                            <v-btn color="info" outlined small @click="importacionConstanciaDetalleGet()">
                                                <v-icon>refresh</v-icon>
                                                Refrescar
                                            </v-btn>

                                        </v-col>

                                        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
                                            <buscador-campos
                                                ref="buscador"
                                                :cargando="loading"
                                                :ancho-selector="{sm: 5, md: 5}"
                                                :ancho-campo="{sm: 7, md: 7}"
                                                @buscar="buscar"
                                                @limpiar="buscar({texto: '', campo: 'todos', persona: null})"
                                            />
                                        </v-col>

                                        <v-col cols="12">
                                            <v-data-table
                                                dense
                                                class="elevation-1"
                                                :headers="tableHeaders"
                                                :items="importacionDetalle"
                                                :loading="loading"
                                                item-key="curso_id"
                                                fixed-header
                                                height="65vh"
                                                :hide-default-footer="true"
                                                disable-pagination
                                            >
                                                <template v-slot:item="{ item }">
                                                    <tr>
                                                        <td class="text-left text-no-wrap" v-html="resaltar(item.numero_identidad, 'identidad')"></td>
                                                        <td class="text-left" v-html="resaltar(item.nombres_apellidos, 'nombre')"></td>
                                                        <td class="text-left" v-html="resaltar(item.registro, 'registro')"></td>
                                                        <td class="text-left">
                                                            <span v-html="resaltar(item.curso, 'curso')"></span>
                                                            <div class="text-caption grey--text text--darken-1"
                                                                 v-if="item.codigo_curricula || item.plataforma || item.nombre_exacto"
                                                                 :title="item.nombre_exacto ? 'Nombre exacto: ' + item.nombre_exacto : ''">
                                                                <v-icon x-small>fact_check</v-icon>
                                                                {{ [item.codigo_curricula, item.plataforma].filter(Boolean).join(' · ') || item.nombre_exacto }}
                                                            </div>
                                                        </td>
                                                        <td class="text-left">{{ item.fecha_inicio | fechaESP }}</td>
                                                        <td class="text-left">{{
                                                                item.fecha_finalizacion | fechaESP
                                                            }}
                                                        </td>
                                                        <td class="text-left">{{
                                                                item.fecha_certificado | fechaESP
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                :color="(item.aprobado) ? 'success' : 'error'"
                                                                outlined
                                                                pill
                                                            >
                                                                {{ item.nota }}
                                                            </v-chip>
                                                        </td>
                                                        <td class="text-left">{{ item.tutor }}</td>
                                                    </tr>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-alert dense type="warning" outlined class="text-center mt-3">
                                                        No existen registros.
                                                    </v-alert>
                                                </template>

                                            </v-data-table>
                                            <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina"
                                                        v-if="pagination.total"/>
                                        </v-col>

                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel v-if="importacionMaestro.puede_eliminar">
                                <v-expansion-panel-header>
                                    <v-toolbar-title>
                                        ¿Quiere Eliminar esta Importación <b>{{importacionMaestro.numero}}</b>?. Esta operación Eliminará toda la Data Importada.
                                    </v-toolbar-title>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-form ref="form" v-model="valid">

                                        <v-text-field
                                            v-model="importacionModel.observacion"
                                            :label="importacionForm.observacion.label"
                                            :rules="importacionForm.observacion.rules"
                                            required
                                            prepend-icon="description"
                                        />

                                    </v-form>
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="text-center py-3">

                                        <v-btn small color="error" :loading="loading"
                                               @click.stop="eliminarImportacion()" :disabled="!valid">
                                            <v-icon>delete</v-icon>
                                            SI, Eliminar, estoy de Acuerdo
                                        </v-btn>

                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </v-card-text>
                    <v-divider class="mt-1"></v-divider>
                    <v-card-actions class="justify-center py-3">

                        <v-btn small outlined @click="regresar">
                            <v-icon>arrow_back</v-icon>
                            Regresar
                        </v-btn>

                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import Auth from "@/services/auth";
const Pagination = () => import("@/pages/Components/Pagination.vue");
import BuscadorCampos from "@/components/Buscador/BuscadorCampos.vue";

export default {
    name: "AdministracionImportacionesConstanciasVer",
    components: {Pagination, BuscadorCampos},
    data() {
        return {
            permisos: [],
            search: "",
            campo: "todos",
            secuenciaConsulta: 0,
            pagination: {},
            importacionConstanciaDetalle: [],
            importacionMaestro: {},
            pageActual: 1,
            rowsPage: this.$store.state.arrayRowsPages[0],
            valid: true,
            loading: false,
            panel: [0],
            tableHeaders: [
                {
                    text: 'Identidad',
                    value: 'numero_identidad',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Nombres Participante',
                    value: 'nombres_apellidos',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Registro',
                    value: 'registro',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Curso',
                    value: 'curso',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha Inicio',
                    value: 'fecha_inicio',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha Fin',
                    value: 'fecha_fin',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha Certificado',
                    value: 'fecha_certificado',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Nota',
                    value: 'nota',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Tutor',
                    value: 'tutor',
                    align: 'left',
                    sortable: false,
                },
            ],
            importacionModel: {
                importacion_id: null,
                observacion: null,
            },
            importacionForm: {
                observacion: {
                    label: "Observación",
                    placeholder: 'Escriba una Observación para Eliminar',
                    rules: [
                        (v) => !!v || 'Campo requerido',
                        (v) => !!v && v.length >= 10 || `La Observación tiene que ser mayor a 10 caracteres.`,
                    ],
                },
            },
        }
    },
    computed: {
        rangoRegistros() {
            const m = this.importacionMaestro;
            if (!m || !m.registro_cantidad) return "Sin números de registro";
            const rango = m.registro_desde === m.registro_hasta ? `${m.registro_desde}` : `Del ${m.registro_desde} al ${m.registro_hasta}`;
            return `${rango}  ·  ${m.registro_cantidad} ${m.registro_cantidad === 1 ? 'registro' : 'registros'}`;
        },
        rangoConsecutivo() {
            const m = this.importacionMaestro;
            if (!m || !m.registro_cantidad) return true;
            return Number(m.registro_hasta) - Number(m.registro_desde) + 1 === Number(m.registro_cantidad);
        },
    },
    methods: {
        buscar(criterio) {
            this.search = criterio.texto;
            this.campo = criterio.campo;
            this.pageActual = 1;
            this.importacionConstanciaDetalleGet();
        },
        resaltar(valor, columna) {
            const buscador = this.$refs.buscador;
            return buscador ? buscador.resaltar(valor, columna) : (valor || "");
        },
        importacionConstanciaDetalleBuscar() {
            this.pageActual = 1;
            this.importacionConstanciaDetalleGet();
        },
        importacionConstanciaDetalleGet() {
            this.loading = true;
            const secuencia = ++this.secuenciaConsulta;

            let params = {
                importacion_id: this.importacionModel.importacion_id,
                busqueda: this.search,
                campo: this.campo,
                page: this.pageActual,
                rowsPage: this.rowsPage
            };

            window.axios.get('/cursos/por_importacion_constancia', {params}).then(response => {
                if (secuencia !== this.secuenciaConsulta) return;
                if (response.data.success) {

                    let data = response.data.data;
                    this.importacionDetalle = data.cursos.data;
                    this.pagination = data.pagination;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        importacionMaestroGet() {
            this.loading = true;

            let params = {
                importacion_id: this.importacionModel.importacion_id
            };

            window.axios.get('/importaciones_constancias/maestro', {params}).then(response => {
                if (response.data.success) {

                    let data = response.data.data;
                    this.importacionMaestro = data;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        eliminarImportacion() {
            this.loading = true;

            window.axios.post('/importaciones_constancias/delete', this.importacionModel).then(response => {
                if (response.data.success) {

                    this.$toast.success(response.data.message);
                    this.regresar();

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.importacionConstanciaDetalleGet();
        },
        verificarToken() {

            if (typeof this.$route.query.token !== "undefined") {
                try {
                    let token = this.$route.query.token;
                    this.importacionModel.importacion_id = window.atob(token);

                    this.importacionMaestroGet();
                    this.importacionConstanciaDetalleGet();
                } catch (e) {
                    console.log(e);
                    this.$toast.error("El parametro para Ver no es valido.");
                    this.regresar();
                }

            } else {
                this.$toast.error("Debe enviar un parametro para Ver.");
                this.regresar();
            }
        },
        regresar() {
            this.$router.go(-1)
        }
    },
    created() {
        Auth.checkPermisos("/administracion/constancias").then((res) => {
            this.permisos = res;
            this.verificarToken();
        });

    }
}
</script>

<style>

</style>
